module.exports = __webpack_public_path__ + "static/3star-reveal-1c7678f5631af40ff9aca73c975a7f8e.mp3";